import { createRouter, createWebHashHistory } from "vue-router";

import generatedRoutes from "virtual:generated-pages";
import { landingPath } from "../utils/adminAuth";
import { markUpdateAvailable, isChunkLoadError } from "../utils/appUpdate";

// 예시: 인증 상태를 확인하는 함수 (실제 구현에 맞게 수정)
function isAuthenticated() {
  // 예: 토큰이 있으면 인증된 것으로 간주
  return !!localStorage.getItem("token");
}

const routes = [
  {
    path: "/",
    redirect: () => landingPath(),
  },

  // 파일 기반 라우팅 (src/pages/*)에서 자동 생성
  ...generatedRoutes,

  {
    // Catch all 404 라우트 - 다른 모든 라우트 뒤에 배치
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    redirect: () => landingPath(),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// 인증 및 라우트 제목 설정
router.beforeEach((to, _from, next) => {
  document.title = `${to.meta.title || "홈"} | LMS`;

  if (to.meta.requiresAuth && !isAuthenticated()) {
    next({ path: "/signin" });
  } else {
    next();
  }
});

// 배포로 옛 청크가 사라져 페이지 전환용 동적 import 가 실패하면(stale chunk),
// 자동 새로고침 대신 전역 토스트로 사용자가 직접 새로고침하도록 안내(작업 중 입력 유실 방지).
router.onError((err) => {
  if (isChunkLoadError(err)) markUpdateAvailable();
});

export default router;
